import { Timestamp } from '@firebase/firestore';
import { Batch } from '../models/Batch';

// Utility to diff in days between two dates
const daysBetween = (start: Date | Timestamp, end: Date | Timestamp) => {
  const s = start instanceof Date ? start : start.toDate();
  const e = end instanceof Date ? end : end.toDate();
  return Math.floor((e.getTime() - s.getTime()) / (1000 * 60 * 60 * 24));
};

export const getCurrentDayInRecipe = (batch: Batch): number => {
  if (!batch.startDate || !batch.recipe) return 0;

  const today = new Date();
  const daysElapsed = daysBetween(batch.startDate, today);

  // Cap to total days in recipe
  const totalDays = batch.recipe.steps.reduce((total, step) => total + (step.duration || 0), 0) || 1;

  return Math.min(daysElapsed + 1, totalDays); // +1 so day 0 → day 1
};
